import React from "react";
import { Col, Container, ListGroup, Row } from "react-bootstrap";
import { Link, useLoaderData } from "react-router-dom";

import "../../assets/css/majorybl/pages/fields.scss";
import { getFieldsList } from "../../lib/api";
import { IField } from "../../types/api";

export const loader = async () => {
    const { fields } = await getFieldsList(true);

    return fields;
};

const Fields = (): React.JSX.Element => {
    const fieldList = useLoaderData() as IField[];

    const fieldLetters = new Set<string>();
    fieldList
        .filter(f => f.active === 1)
        .forEach(i => {
            const firstChar = i.name.charAt(0).toUpperCase();
            fieldLetters.add(isNaN(parseInt(firstChar)) ? firstChar : "#");
        });

    const sortedLetters = Array.from(fieldLetters).sort();

    return (
        <div data-testid="fieldsContent">
            <Container className="py-5 fields">
                <Row>
                    <Col>
                        <ListGroup
                            horizontal
                            as="ul"
                            id="letterList"
                            className="list-group-links"
                        >
                            {sortedLetters.map(l => (
                                <ListGroup.Item key={l} as="li">
                                    <a href={`#${l}`}>{l}</a>
                                </ListGroup.Item>
                            ))}
                        </ListGroup>

                        {sortedLetters.map(letter => (
                            <div
                                key={letter}
                                id={letter}
                                className="fieldSection"
                            >
                                <h2 className="border-bottom-dark">{letter}</h2>
                                <ul>
                                    {fieldList
                                        .filter(f => f.active === 1)
                                        .filter(({ name }) => {
                                            const firstChar = name
                                                .charAt(0)
                                                .toUpperCase();

                                            if (letter === "#") {
                                                return !isNaN(
                                                    parseInt(firstChar),
                                                );
                                            } else {
                                                return letter === firstChar;
                                            }
                                        })
                                        .sort((a, b) =>
                                            a.name.localeCompare(b.name),
                                        )
                                        .map(f => (
                                            <li key={f.id}>
                                                <Link
                                                    to={`/fields/${f.id}`}
                                                    target="_blank"
                                                >
                                                    {f.name}{" "}
                                                    {f.city &&
                                                        f.state &&
                                                        `(${f.city}, ${f.state})`}
                                                </Link>
                                            </li>
                                        ))}
                                </ul>
                                <p>
                                    <a
                                        href="#"
                                        onClick={() => {
                                            window.scrollTo({
                                                top: 0,
                                                behavior: "instant",
                                            });
                                            return false;
                                        }}
                                    >
                                        ^ Back to Top ^
                                    </a>
                                </p>
                            </div>
                        ))}
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Fields;
